import { UserImage } from 'interfaces/userImage'
import { ImageURLs } from 'interfaces/media'
import { createSelector } from 'reselect'
import { createFeedCommentSelector, memberFeedInfoSelector, createRegularPostSelector } from 'selectors/feedSelectors'
import { userImagesCollectionSelector, userImagesByIds } from 'selectors/userImagesSelectors'
import { getItemFromCollection } from 'helpers/normalizeHelpers'

const userImagesToImagesSelector = (userImages: UserImage[]) => userImages.reduce<ImageURLs[]>((acc, userImage) => {
  if (userImage.image) {
    acc.push(userImage.image)
  }
  return acc
}, [])

export const createFeedPostImagesSelector = () => {
  const feedPostImagesIdsSelector = createSelector(
    createRegularPostSelector(),
    (post) => ({
      ids: post ? post.imagesIds : [],
    })
  )

  const feedPostUserImagesSelector = createSelector(
    userImagesCollectionSelector,
    feedPostImagesIdsSelector,
    userImagesByIds,
  )

  return createSelector(
    feedPostUserImagesSelector,
    userImagesToImagesSelector
  )
}

export const createFeedCommentImagesSelector = () => {
  const feedCommentImagesIdsSelector = createSelector(
    createFeedCommentSelector(),
    (comment) => ({
      ids: comment ? comment.imagesIds : [],
    })
  )

  const feedCommentImagesSelector = createSelector(
    userImagesCollectionSelector,
    feedCommentImagesIdsSelector,
    userImagesByIds,
  )

  return createSelector(
    feedCommentImagesSelector,
    userImagesToImagesSelector
  )
}

const memberAvatarIdSelector = createSelector(
  memberFeedInfoSelector,
  (member) => member ? member.avatarId || null : null
)

export const feedMemberAvatarSelector = createSelector(
  userImagesCollectionSelector,
  memberAvatarIdSelector,
  (userImages, id) => {
    if (!userImages) {
      return null
    }
    return getItemFromCollection<UserImage, 'id'>(userImages, id)
  }
)
